module.exports = __webpack_public_path__ + "img/BGS02.fbaf986f.png";